module.exports = __webpack_public_path__ + "img/cyber-security-cybersecurity-device-60504.684b4259.jpg";